/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useLocationsList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const LocationSelect = ({ placeholder = 'Type the name of location...', ...props }) => (
  <SearchableEntitySelect placeholder={placeholder} useList={useLocationsList} {...props} />
);

export default LocationSelect;
